module.exports = __webpack_public_path__ + "img/p5.355119e5.svg";